import { useBienContext } from '../BienContext'

import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { Checkbox, Input } from '@/components/ui'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'espaces_annexes'
  const SECTION_TITLE = "Espaces et annexes"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les espaces et annexes"
  />

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Pièces" value={bien.pieces} valueClassName="uppercase" />
        <Input.Display label="Chambres" value={bien.chambres} valueClassName="uppercase" />
        <Input.Display label="Salle de bain" value={bien.salle_de_bain} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="Salle de douche" value={bien.salle_de_douche} valueClassName="uppercase" />
        <Input.Display label="WC" value={bien.wc} valueClassName="uppercase" />
        <Input.Display label="Parking" value={bien.parking} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-2">
          {[{label: "Terrasse", value: bien.terrasse},
            {label: "Véranda", value: bien.veranda},
            {label: "Balcon", value: bien.balcon},
            {label: "Grenier", value: bien.grenier},
            {label: "Jardin", value: bien.jardin},
            {label: "Cave", value: bien.cave},
            {label: "Piscine", value: bien.piscine},
            {label: "Cellier", value: bien.cellier},
            {label: "Spa", value: bien.spa},
            {label: "Buanderie", value: bien.buanderie},
            {label: "Garage", value: bien.garage},
          ].map(
            (item, index) => <Checkbox.Display key={index} item={item} />
          )}
        </div>
      </div>

    </DetailTemplate>
  )
}